import { Badge } from "@/components/ui/badge";

export function LastUsedIndicator() {
  return (
    <Badge 
      variant="secondary" 
      className="absolute -top-1 -right-1 px-1.5 py-0.5 text-[10px] font-medium bg-primary text-primary-foreground border-primary"
    >
      Last used
    </Badge>
  );
}